import { useLazyQuery } from '@apollo/react-hooks'
import { gql } from 'apollo-boost'

export interface IHawkbitActionDistributionSet {
  id: number
  name: string | null
  version: string | null
}

export interface IHawkbitAction {
  id: number
  type: string | null
  status: string | null
  detailStatus: string | null
  forceType: string | null
  distributionSet: IHawkbitActionDistributionSet | null
  createdAt: number | null
  lastModifiedAt: number | null
}

export interface IHawkbitActionPage {
  content: IHawkbitAction[]
  total: number
  size: number
}

interface HawkbitTargetActionsData {
  hawkbitTargetActions: IHawkbitActionPage
}

interface HawkbitTargetActionsVariables {
  controllerId: string
  limit: number
  offset: number
}

export const HAWKBIT_TARGET_ACTIONS_QUERY = gql`
  query HawkbitTargetActions($controllerId: String!, $limit: Int, $offset: Int) {
    hawkbitTargetActions(controllerId: $controllerId, limit: $limit, offset: $offset) {
      content {
        id
        type
        status
        detailStatus
        forceType
        distributionSet {
          id
          name
          version
        }
        createdAt
        lastModifiedAt
      }
      total
      size
    }
  }
`

export const useHawkbitTargetActions = () => {
  return useLazyQuery<HawkbitTargetActionsData, HawkbitTargetActionsVariables>(HAWKBIT_TARGET_ACTIONS_QUERY, {
    fetchPolicy: 'network-only'
  })
}
